export default __webpack_public_path__ + "static/media/lote.96bbbc6a.svg";